import {FetchConsts} from '../hooks/fetchConsts'
import createUUID from './guid'
import axiosInstance from '../utils/axios'

class AuthService {
  getRememberMe() {
    return JSON.parse(localStorage.getItem(FetchConsts.rememberMeName))
  }

  setRememberMe(rememberMe) {
    localStorage.setItem(FetchConsts.rememberMeName, JSON.stringify(rememberMe))
  }

  getJwtToken() {
    if (this.getRememberMe()) return localStorage.getItem(FetchConsts.token)
    return sessionStorage.getItem(FetchConsts.token)
  }

  getRefreshToken() {
    if (this.getRememberMe())
      return localStorage.getItem(FetchConsts.refreshToken)
    return sessionStorage.getItem(FetchConsts.refreshToken)
  }

  setJwtToken(token) {
    if (this.getRememberMe()) localStorage.setItem(FetchConsts.token, token)
    else sessionStorage.setItem(FetchConsts.token, token)
  }

  setRefreshToken(refreshToken) {
    if (this.getRememberMe())
      localStorage.setItem(FetchConsts.refreshToken, refreshToken)
    else sessionStorage.setItem(FetchConsts.refreshToken, refreshToken)
  }

  deleteJwtToken() {
    if (this.getRememberMe()) return localStorage.removeItem(FetchConsts.token)
    return sessionStorage.removeItem(FetchConsts.token)
  }

  deleteRefreshToken() {
    if (this.getRememberMe())
      return localStorage.removeItem(FetchConsts.refreshToken)
    return sessionStorage.removeItem(FetchConsts.refreshToken)
  }

  setSession(jwtToken, refreshToken) {
    if (jwtToken && refreshToken) {
      this.setJwtToken(jwtToken)
      this.setRefreshToken(refreshToken)
    } else {
      this.deleteJwtToken()
      this.deleteRefreshToken()
    }
  }

  getAdminToken = () => {
    return sessionStorage.getItem('adminToken')
  }

  isAuthenticated = () => !!this.getJwtToken() && !!this.getRefreshToken()

  getDeviceId() {
    const deviceIdName = 'deviceId'
    let id = localStorage.getItem(deviceIdName)
    if (!id) {
      id = createUUID()
      localStorage.setItem(deviceIdName, id)
    }
    return id
  }

  clearSession = () => sessionStorage.clear()

  refreshToken = (
    // eslint-disable-next-line no-empty-function
    onResponseCallback = () => {},
    // eslint-disable-next-line no-empty-function
    onErrorCallback = () => {}
  ) => {
    const refreshTokenValue = authService.getRefreshToken()
    const jwtToken = authService.getJwtToken()

    axiosInstance
      .post('/token/refresh', {
        token: jwtToken,
        refreshToken: refreshTokenValue,
        deviceId: authService.getDeviceId(),
      })
      .then(({data: refreshResponse}) => {
        const {token} = refreshResponse
        authService.setJwtToken(token)

        onResponseCallback(refreshResponse)
      })
      .catch(({response: refreshTokenError}) => {
        onErrorCallback(refreshTokenError)
      })
  }

  updateRefreshToken = (
    // eslint-disable-next-line no-empty-function
    onResponseCallback = () => {},
    // eslint-disable-next-line no-empty-function
    onErrorCallback = () => {}
  ) => {
    const oldRefreshToken = authService.getRefreshToken()
    const deviceId = authService.getDeviceId()

    const body = {
      deviceId: deviceId,
      oldRefreshToken: oldRefreshToken,
    }

    axiosInstance
      .post('/token/updateRefreshToken', body)
      .then(({data: newRefreshToken}) => {
        authService.setRefreshToken(newRefreshToken)

        setTimeout(() => {
          axiosInstance
            .post('/token/deleteOldRefreshToken', body)
            .then(() => {
              onResponseCallback()
            })
            .catch(() => {
              onErrorCallback()
            })
        }, 1000)
      })
      .catch(() => {
        onErrorCallback()
      })
  }
}

const authService = new AuthService()

export default authService
